import { useContext } from "react";
import { AppContext } from "../App";

const GoogleTransTwo = (props) => {
  const { setTransOpen } = useContext(AppContext);
  const click =()=>{
    setTransOpen(true)
    props.burger()
  }
  return (
    <div
    className="lang"
      onClick={click}
    >
 
      تغير اللغة
    </div>
  );
};

export default GoogleTransTwo;
